import { PdfAction } from '@app/libs/reactPdfJs/store/actions';
import { PDF_CLEAR_ALL_STATE, PDF_PAGE_VIEWPORT_SET } from '@app/libs/reactPdfJs/store/actionTypes';
import PageViewport from '@app/libs/reactPdfJs/store/PageViewport';

type PdfPageViewportSizes = PageViewport[];

const initialState: PdfPageViewportSizes = [];

export default function reducer(state: PdfPageViewportSizes = initialState, action: PdfAction) {
  switch (action.type) {
    case PDF_CLEAR_ALL_STATE:
      return initialState;
    case PDF_PAGE_VIEWPORT_SET:
      return action.payload.map(({ pageNumber, width, height }) => ({ pageNumber, width, height }));
    default:
      return state;
  }
}
